export default "__VITE_ASSET__2b93a305__"